import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatCurrentPosition = ({
	cp_title: title,
	cp_time_period: timePeriod,
}) => {
	let currentPosition = title;

	if (timePeriod) {
		currentPosition += `, ${timePeriod}`;
	}

	return currentPosition;
};

const CurrentPositions = (props) => {
	const currentPositions = props.data.current_positions;

	if (!_.isArray(currentPositions) || _.isEmpty(currentPositions)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(currentPositions, currentPosition => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatCurrentPosition(currentPosition)}
				</li>
			))}
		</ul>
	);
};

CurrentPositions.propTypes = {
	data: PropTypes.object.isRequired,
};

export default CurrentPositions;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/current-positions.js